<template>
  <div class="after">
    <z-notice-bar
      text="为详细调查您所遇到的问题，请填写以下凭证"
      left-icon="https://dl.zhuanstatic.com/fecommon/公告小喇叭.svg"
    >
    </z-notice-bar>
    <div class="content">
      <div v-show="isOutSide">
      <EvidenceBlock :accept="'image/*'" :max="5" :Finished="evidenceFinish1" :evidenceData="evidenceDataOutside1"></EvidenceBlock>
      <EvidenceBlock :Finished="evidenceFinish2" :evidenceData="evidenceDataOutside2"></EvidenceBlock>
      </div>
      <div v-show="!isOutSide">
        <EvidenceBlock :Finished="evidenceFinish3" :evidenceData="evidenceDataNotout"></EvidenceBlock>
        <SelectRadio :Finished="radioFinish" :radioData="radioData"></SelectRadio>
      </div>
    </div>
    <z-button-group>
      <z-button :loading="sharedData.globalLoading" :disabled="!canSubmit" type="primary" @click="next">提交</z-button>
    </z-button-group>
  </div>
</template>

<script>
import { Button, ButtonGroup, NoticeBar } from '@zz-common/zz-ui'
import SelectRadio from '../../components/SelectRadio'
import EvidenceBlock from '../../components/EvidenceBlock'
export default {
  name: 'AfterFraud',
  components: {
    zButton: Button,
    zButtonGroup: ButtonGroup,
    EvidenceBlock,
    SelectRadio,
    'z-notice-bar': NoticeBar
  },
  data() {
    return {
      content: '', //凭证描述 多个用逗号分割
      guideContent: '', //引导描述
      outsideCommunication: '', //是否有站外沟通 0没有 1有  不选传null
      outsidePic: [], //站外沟通凭证照片

      outsideEvidence1: {
        message: '',
        files: []
      },
      outsideEvidence2: {
        message: '',
        files: []
      },
      insideEvidence: {
        message: '',
        files: []
      }
    }
  },
  inject: ['sharedData', 'mergeSubmitData', 'globalSubmit', 'submitData', 'files2PicAndVideo', 'setNavTitle'],
  computed: {
    canSubmit() {
      if (this.sharedData.evidenceLoading) return false
      if (this.isOutSide) {
        return this.outsideEvidence1.message.length >= 5 && this.outsideEvidence1.files.length > 0 && this.outsideEvidence2.message.length >= 5 && this.outsideEvidence2.files.length > 0
      } else {
        if (this.outsideCommunication === 0) {
          return this.insideEvidence.message.length >= 5 && this.insideEvidence.files.length > 0
        } else {
          return this.insideEvidence.message.length >= 5 && this.insideEvidence.files.length > 0 && this.outsidePic.length > 0
        }
      }
    },
    isOutSide() {
      return this.submitData.tradingChannel === '204'
    },
    evidenceDataOutside1() {
      //卖家
      if (this.submitData.userRole == '22') {
        return {
          title: '请填写相关引导描述',
          placeholder: '请简要描述买家如何引导您去平台外交易，包括对方的联系方式',
          text: '如您在平台外发生转账/付款，请上传完整转账/付款截图',
          example_title: '转账/付款凭证示例',
          example_text: '上传您在站外<b>转账、付款</b>的截图，包括对⽅<b>账号信息</b>',
          example: 'https://pic6.zhuanstatic.com/zhuanzh/507f8479-b448-46b8-aeb7-24c3ef1f0401.png|https://pic3.zhuanstatic.com/zhuanzh/fd8e5513-02bb-41dd-aa06-83774d8d0c03.png|https://pic5.zhuanstatic.com/zhuanzh/4f4a14c1-da10-4df2-8074-39d26fb6a868.png|https://pic5.zhuanstatic.com/zhuanzh/deea2255-922d-4209-bd26-f8709696dcd9.png'
        }
      }
      //买家
      if (this.submitData.userRole == '21') {
        return {
          title: '请填写相关引导描述',
          placeholder: '请简要描述卖家如何引导您去平台外交易，包括对方的联系方式',
          text: '如您在平台外发生转账/付款，请上传完整转账/付款截图',
          example_title: '转账/付款凭证示例',
          example_text: '上传您在站外<b>转账、付款</b>的截图，包括对⽅<b>账号信息</b>',
          example: 'https://pic6.zhuanstatic.com/zhuanzh/507f8479-b448-46b8-aeb7-24c3ef1f0401.png|https://pic3.zhuanstatic.com/zhuanzh/fd8e5513-02bb-41dd-aa06-83774d8d0c03.png|https://pic5.zhuanstatic.com/zhuanzh/4f4a14c1-da10-4df2-8074-39d26fb6a868.png|https://pic5.zhuanstatic.com/zhuanzh/deea2255-922d-4209-bd26-f8709696dcd9.png'
        }
      }
      return {}
    },
    evidenceDataOutside2() {
      //卖家
      if (this.submitData.userRole == '22') {
        return {
          title: '请填写相关事件经过',
          placeholder: '请描述您与买家在平台外发生的事情经过',
          text: '请上传您与对方在平台外的所有沟通截图或视频',
          example_title: '聊天凭证示例',
          example_text: '上传您与对方在站外的<b>完整聊天截图</b>',
          example: 'https://pic1.zhuanstatic.com/zhuanzh/f6fd9030-1dc6-4948-8941-3a502d695b31.png'
        }
      }
      //买家
      if (this.submitData.userRole == '21') {
        return {
          title: '请填写相关事件经过',
          placeholder: '请描述您与卖家在平台外发生的事情经过',
          text: '请上传您与对方在平台外的所有沟通截图或视频',
          example_title: '聊天凭证示例',
          example_text: '上传您与对方在站外的<b>完整聊天截图</b>',
          example: 'https://pic1.zhuanstatic.com/zhuanzh/f6fd9030-1dc6-4948-8941-3a502d695b31.png'
        }
      }
      return {}
    },
    evidenceDataNotout() {
      //假冒商品
      if (this.submitData.questionId == '2120302') {
        return {
          title: '请填写相关凭证',
          placeholder: '请简要描述商品问题与交易经过',
          text: '请参考凭证提示，上传商品鉴定凭证(图片/视频)',
          ...this.exampleData
        }
      }
      return {
        title: '请填写相关凭证',
        placeholder: '请描述您与对方发生的事情经过',
        text: '请参考凭证提示，上传相应凭证(图片/视频)',
        ...this.exampleData
      }
    },
    radioData() {
      return {
        question: '您与对方是否有平台外沟通',
        answer: [
          {
            id: 0,
            desc: '否'
          },
          {
            id: 1,
            desc: '是',
            outer: true
          }
        ]
      }
    },
    exampleData() {
      //我是买家-转转订单交易，有损失-收到假冒商品
      if (this.submitData.questionId == '2120302') {
        return {
          example_title: '凭证示例',
          example_text: '1.该商品正品图⽚与您所收到商品图⽚<b>真假对⽐图</b>，如⽆法找到正品图⽚， 请您尽可能按照鉴别⽅法，拍摄<b>清晰的商品细节</b><br>2.如该商品存在专业的鉴别机构，请您提供该商品<b>鉴别结果截图</b>',
          example: 'https://pic6.zhuanstatic.com/zhuanzh/5d8e2199-01de-4a71-bcaf-6a7b01eb5906.png|https://pic6.zhuanstatic.com/zhuanzh/25697df1-48d2-4e38-b667-0b6664f7fe62.png|https://pic5.zhuanstatic.com/zhuanzh/bc421a97-ac60-495e-b5f3-686c3cc4a242.png'
        }
        //我是买家-转转订单交易，有损失-未收到货/收到空包裹/卖家发虚假链接等
      } else if (this.submitData.userRole == '21' && this.submitData.tradingChannel == '203') {
        return {
          example_title: '凭证示例',
          example_text: `1.收到空包裹：上传包裹开箱视频，请仔细拍摄包裹上的快递标签<br>
                         2.虚假链接：上传关键聊天截图、虚假链接内容<br>
                         3.退货卖家不退款：上传关键聊天截图、退货物流单号、最新物流信息截图<br>
                         4.游戏账号被找回：账号⽆法登录凭证<br>
                         5.其他问题：对方涉及违规的关键聊天截图、交易商品图片等`
        }
        //我是买家-没有损失--所有问题
      } else if (this.submitData.userRole == '21' && this.submitData.tradingChannel == '202') {
        return {
          example_title: '违规凭证示例',
          example_text: `1.上传关键的聊天截图，对⽅引导您的操作截图<br>
                        2.如存在货品交易，请上传收货商品的图⽚、使用视频`
        }
        //我是卖家-转转订单交易，有损失-所有问题
      } else if (this.submitData.userRole == '22' && this.submitData.tradingChannel == '203') {
        return {
          example_title: '凭证示例',
          example_text: `1.退货被损坏：请提供您所收到退货的商品图⽚与发货前商品图⽚，如存在功能问题，请上传相应视频 <br>
                        2.冒充官⽅：请上传对⽅冒充转转官⽅的全过程聊天截图 <br>
                        3.租售账号被毁号：请最能体现该账号被毁号的证据截图，包括账号的基本信息`
        }
        //我是卖家-没有损失-所有问题
      } else if (this.submitData.userRole == '22' && this.submitData.tradingChannel == '202') {
        return {
          example_title: '违规凭证示例',
          example_text: `1.上传关键的聊天截图，对⽅引导您的操作截图<br>
                        2.如存在货品交易，请上传发货/收货商品的图⽚、视频`
        }
      }
      return {}
    }
  },
  methods: {
    next() {
      if (this.isOutSide) {
        this.mergeSubmitData({
          productCategory: '',
          phoneQuestionDesc: '',
          guideContent: this.outsideEvidence1.message,
          pics: JSON.stringify(this.files2PicAndVideo(this.outsideEvidence1.files).concat(this.files2PicAndVideo(this.outsideEvidence2.files))),
          content: this.outsideEvidence1.message + ',' + this.outsideEvidence2.message
        })
      } else {
        this.mergeSubmitData({
          //下面两个在另一个流程里面的数据清空，因为用户可能回退
          productCategory: '',
          phoneQuestionDesc: '',
          guideContent: this.outsideEvidence1.message,
          outsideCommunication: this.outsideCommunication,
          outsidePic: JSON.stringify(this.outsidePic),
          pics: JSON.stringify(this.files2PicAndVideo(this.insideEvidence.files)),
          content: this.insideEvidence.message
        })
      }
      this.globalSubmit(this.submitData)
    },
    evidenceFinish1(data) {
      this.outsideEvidence1 = data
    },
    evidenceFinish2(data) {
      this.outsideEvidence2 = data
    },
    evidenceFinish3(data) {
      this.insideEvidence = data
    },
    radioFinish(data) {
      this.outsideCommunication = data.evidence
      this.outsidePic = data.outerUpload.map(t => t.url)
    }
  },
  activated() {
    this.setNavTitle('举报凭证')
    console.log('看看现在的submitdata', this.submitData)
  }
}
</script>

<style lang="less" scoped>
@import "index.less";
</style>